












import Vue from 'vue'
import { mapGetters } from 'vuex'
import { GETTERS_ACTIONS } from '@/types'

export default Vue.extend({
  computed: {
    ...mapGetters([GETTERS_ACTIONS.EXPORT_JSON]),
    url () {
      const JSONData = this.getJSON() as string
      return 'data:' + JSONData
    }
  },
  methods: {
    getJSON (): string {
      return this.exportJSON
    }
  }
})
